import { useEffect, useState } from "react";
import { LugarMovilizacionService } from "../../../services/movilizacion/LugarMovilizacionService";
import TransporteService from "../../../services/transporteService";
import {
  IBase,
  IException,
  IItemComboBaseDTO,
} from "../../../interfaces/base/IBase";
import { IRequestAsignarEmpresa } from "../../../interfaces/ubicacion/IUbicacion";
import { codigosRespuesta, IResponseApiFluent } from "../../../interfaces/base/IResponse";

const UseAsignarEmpresa = (
  dataMov?: any,
  isOpen?: any,
  onDismiss?: any,
  reloadInitial?: any
) => {
  const [movilizacionEmpresa, setMovilizacionEmpresa] = useState<any[]>([]);
  const movId = dataMov?.lugarMovilizacionId;
  const [transporte, setTransporte] = useState<IItemComboBaseDTO[]>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [mensaje, setMensaje] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<codigosRespuesta>(0);
  const [confirmacion, setConfirmacion] = useState<boolean>(false);
  const [request, setRequest] = useState<IRequestAsignarEmpresa>({
    empresaId: "",
    lugarMovilizacionId: movId,
  });

  const getUbicacion = () => {
    // setLoading(true);
    LugarMovilizacionService.ListarMovilizacionEmpresa(movId)
      .then((res) => {
        setMovilizacionEmpresa(res.data);

        // setLoading(false);
      })
      .catch((e: any) => {
        // setLoading(false);
      });
  };

  const dataTransporte = () => {
    TransporteService.allSocioTransportista()
      .then((res) => {
        let d: IBase[] = res.data;

        let t: IItemComboBaseDTO[] = d.map((x) => {
          return {
            key: x.id,
            text: x.nombre,
          };
        });

        setTransporte(t);
      })
      .catch((e: IException) => {
        console.log(e);
      });
  };

  const AgregarEmpresa = () => {
    setLoading(true);
    const currentRequest = { ...request };
    LugarMovilizacionService.AsignarMovilizacionEmpresa(currentRequest)
      .then((res) => {

        if(res.status === 200){
          setStatus(200)
          setMensaje(res.data.mensaje);
          setTimeout(() => {
            onDismiss();
          }, 2000);
          reloadInitial();
        }else
        {
          setStatus(500)
          setRequest({
            empresaId: "",
            lugarMovilizacionId: movId,
          });
        }
        setLoading(false);
       
       
      })
      .catch((e: any) => {
        if (
          e.response?.data &&
          'type' in e.response.data &&
          'title' in e.response.data &&
          'status' in e.response.data &&
          'instance' in e.response.data &&
          'errors' in e.response.data
      ) {
          const errorResponse = e.response.data as IResponseApiFluent;
          const mensajeError = errorResponse.errors.join('\n');
          setMensaje(mensajeError);
      } else {
          setMensaje("Error Inesperado");
      }
      setStatus(500);
      setLoading(false);
      });
  };

  const onchangeCombo = (option: any, key: string) => {
    if (option) {
      setRequest((prevRequest) => ({
        ...prevRequest,
        [key]: option.key,
      }));
      setDisabled(false);
    }
  };
  useEffect(() => {
    if (mensaje !== "") {
      setTimeout(() => {
        setMensaje("");
      }, 3000);
    }
  }, [mensaje]);

  useEffect(() => {
    getUbicacion();
  }, []);

  useEffect(() => {
    if (isOpen) {
      {
        dataTransporte();
      }
    }
  }, [isOpen]);

  return {
    movilizacionEmpresa,
    transporte,
    setRequest,
    request,
    onchangeCombo,
    disabled,
    setDisabled,
    getUbicacion,
    AgregarEmpresa,
    mensaje,
    status,
    loading,
    setLoading,
    setStatus,
    setMensaje,
    confirmacion,
  };
};

export default UseAsignarEmpresa;
